import { Injectable } from '@angular/core';
import { UploadedFile } from '@vinnova/ui';
import { delay, Observable, of, switchMap, throwError } from 'rxjs';
import { v7 as uuid } from 'uuid';

/**
 * This class has to be extended and overriden
 * on the application using formrenderer library.
 */
@Injectable({
  providedIn: 'root',
})
export class BaseFileService {
  // Den här property styr ifall man vill gå mot en riktig eller fake server
  // Det bor alltid checkas in som false
  private readonly FAKE_SERVER_ERROR_ON_UPLOAD = false;
  private readonly FAKE_SERVER_ERROR_ON_DELETE = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public downloadFile(fileId: string, fileName: string): Observable<void> {
    return throwError(
      () => new Error('BaseFileService has not been implemented'),
    );
  }

  public uploadFile(
    file: File,
    fileName: string,
  ): Observable<FormUploadedFile | FormUploadedSigneringFile> {
    return this.uploadFileToFakeServer(file, fileName);
  }

  public deleteFile(fileId: string): Observable<void> {
    return this.deleteFileFromFakeServer(fileId);
  }

  private uploadFileToFakeServer(
    file: File,
    fileName: string,
  ): Observable<FormUploadedFile> {
    const result = of({
      pdfFileId: uuid(),
      pdfFileName: fileName + '.pdf',
      originalFileName: file.name,
    } as FormUploadedFile);

    // Simulera en error på server
    if (
      file.name.toLocaleLowerCase().includes('test') &&
      this.FAKE_SERVER_ERROR_ON_UPLOAD
    ) {
      return result.pipe(
        delay(this.generateRandomNumber(2000)),
        switchMap(() =>
          throwError(() => new Error('Det gick inte att ladda upp fil')),
        ),
      );
    }

    return result.pipe(delay(this.generateRandomNumber(2000)));
  }

  private deleteFileFromFakeServer(_fileId: string): Observable<void> {
    return this.FAKE_SERVER_ERROR_ON_DELETE
      ? of(void 0).pipe(
          delay(this.generateRandomNumber(2000)),
          // simulera en krash vid delete file
          switchMap(() =>
            throwError(() => new Error('Det gick inte att ta bort filen')),
          ),
        )
      : of(void 0).pipe(delay(this.generateRandomNumber(2000)));
  }

  private generateRandomNumber(largest: number): number {
    // eslint-disable-next-line sonarjs/pseudo-random -- used only for fake-server delay simulation
    return Math.floor(Math.random() * largest);
  }
}

export interface FormUploadedFile extends UploadedFile {
  handlingstyp: string;
}

export interface FormUploadedSigneringFile extends UploadedFile {
  handlingstyp: string;
  projektpart?: string;
  rubrik: string;
  rubrikEN: string;
  beskrivning: string;
  beskrivningEN: string;
  signeringstjanst: string;
  signeringstjanstId: string;
  verifieringsURL: string;
  signeradDatumTid: Date;
  signerareLista?: {
    firstName: string;
    lastName: string;
    email: string;
    signeradDatumTid: Date;
  }[];
  digitaltSignerad: boolean;
}
